angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {

    $stateProvider.state('home', {
        url: '/home',
        controller: 'HomeCtrl as vm',
        templateUrl: 'app/view/home/home.html',
    });

}).controller('HomeCtrl', function($scope, $state, $firebaseObject) {

    var vm = this;
    var ref = firebase.database().ref();
    // download the data into a local object
    vm.data = $firebaseObject(ref);
    vm.city = 'SEA';
    vm.cat = 'ALL';

    vm.search = function(){
        $state.go('results', { city: vm.city, cat: vm.cat });
    }

    vm.catSearch = function(){
        $state.go('results', { city: 'ALL', cat: vm.cat });
    }

    var destroy = $scope.$on("$destroy", function() {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});